@use 'styles/colors' as *;
@use 'styles/functions/rem' as *;

.successNotification {
    background-color: $successNotificationBackgroundColor;
    height: rem(46px);
}

.checkmarkIcon {
    color: $inverseTextColor;
}
